// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2322":"72bee207","4036":"72bee207","4145":"72bee207","5035":"72bee207","7617":"72bee207","7720":"72bee207","8592":"72bee207","8840":"72bee207","9171":"72bee207","9592":"72bee207","9610":"72bee207","9887":"72bee207"}[chunkId] + ".chunk.css";
};